module.exports = __webpack_public_path__ + "img/gorod.29aff319.jpg";